// =====================================================
// GeoJSON Chunking Configuration
// =====================================================

export const GEOJSON_CONFIG = {
  // Límites de tamaño
  MAX_SINGLE_FILE_SIZE: 30 * 1024 * 1024,  // 30 MB - umbral para chunking
  TARGET_CHUNK_SIZE: 10 * 1024 * 1024,     // 10 MB por chunk
  MAX_TOTAL_SIZE: 500 * 1024 * 1024,       // 500 MB - rechazar si excede

  // Límites de chunks
  MAX_CHUNKS: 50,                           // Máximo 50 archivos

  // Límites de features
  MIN_FEATURES_PER_CHUNK: 100,              // Mínimo 100 features por chunk
  MAX_FEATURES_PER_CHUNK: 5000,             // Máximo 5000 features por chunk

  // Storage
  BUCKET_SIZE_LIMIT: 100 * 1024 * 1024,    // 100 MB límite del bucket
} as const;

export interface ChunkInfo {
  path: string;
  features: number;
  size_mb: number;
  index: number;
}

export interface UploadResult {
  isChunked: boolean;
  paths: string[];
  totalSize: number;
  totalFeatures: number;
  chunkInfo?: ChunkInfo[];
}
